/**
 * @ngdoc services
 * @memberof mercury.modules.time
 * @name TimeRosteredShifts
 */
angular.module('mercury.modules.time.roster')
  .factory('TimeRosteredShifts', ["$http", "$q", "$resource", "userinfo", "settings", function ($http, $q, $resource, userinfo, settings) {
    var baseShiftUrl = settings.mercHost + '/time/rostered-shifts';

    var TimeRosteredShifts = $resource(baseShiftUrl + '/:id', { id: '@id' });
    var TimeRostersWebAPI = $resource(settings.apiHost + '/r/TimeRosters/:id', { id: '@id' });

    /**
     * [getAllForWeek - get all rostered shifts for a week 
     * filtered by time period range and staff member ids]
     *
     * @memberof TimeRosteredShifts
     * @param  {?} time [time when this is run]
     * @param  {?} staffMemberIds [filter shifts by staff member ids]
     * @return {?}      [rostered shifts]
     */
    function getAllForWeek(time, staffMemberIds) {
      return TimeRosteredShifts.query({
        startTime: moment(time).mStartOf('week').format(),
        endTime: moment(time).mEndOf('week').format(),
        staffMemberIds: staffMemberIds
      }
      ).$promise;
    }

    /**
     * [getAllByRosterId description]
     *
     * @memberof TimeRosteredShifts
     * @param  {?} rosterId
     * @param  {?} staffMemberIds [filter shifts by staff member ids]
     * @return {?} rosteredShifts
     */
    function getAllByRosterId(rosterId, staffMemberIds) {
      return TimeRosteredShifts.query({ rosterId: rosterId, staffMemberIds: staffMemberIds }).$promise;
    }

    /**
     * [getAll description]
     *
     * @memberof TimeRosteredShifts
     * @param  {?} startTime [description]
     * @param  {?} endTime   [description]
     * @return {?}           [description]
     */
    function getAll(startTime, endTime) {
      return TimeRosteredShifts.query({ startTime: moment(startTime).format(), endTime: moment(endTime).format() }).$promise;
    }

    /**
     * [getSummaryForCompany description]
     *
     * @memberof TimeRosteredShifts
     * @param  {?} startTime [description]
     * @param  {?} endTime   [description]
     * @return {?}           [description]
     */
    function getSummary(startTime, endTime, companyId) {
      var deferred = $q.defer();
      var config = { params: { startTime: startTime, endTime: endTime } };

      // Optionally override the company-id header
      if (companyId) {
        config.headers = {
          'x-loaded-company-id': companyId,
          'x-loaded-suppress-subscription-errors': '1'
        };
      }

      $http.get(settings.mercHost + '/time/rostered-shifts-summary', config)
        .then(function (result) {
          deferred.resolve(result.data);
        }, function (result) {
          deferred.reject(result.data);
        });

      return deferred.promise;
    }

    /**
     * [update description]
     *
     * @memberof TimeRosteredShifts
     * @param  {?} rosteredShift [description]
     * @return {?}        [description]
     */
    function update(rosteredShift) {
      return TimeRosteredShifts.update(rosteredShift).$promise;
    }

    /**
     * [copy description]
     *
     * @memberof TimeRosteredShifts
     * @param  {?} soureWeekStart [description]
     * @param  {?} deskWeekStart  [description]
     * @return {?}                [description]
     */
    function copy(soureWeekStart, deskWeekStart) {
      return $resource(baseShiftUrl + '/copyWeek').save({
        sourceWeek: moment(soureWeekStart).mUtcFormat(),
        destinationWeek: moment(deskWeekStart).mUtcFormat()
      }, {}).$promise;
    }

    /**
     * [remove description]
     *
     * @memberof TimeRosteredShifts
     * @param  {?} rosteredShift [description]
     * @return {?}        [description]
     */
    function remove(rosteredShift) {
      rosteredShift.datestampDeleted = moment().mUtcFormat();
      return TimeRosteredShifts.update(rosteredShift).$promise;

    }

    /**
     * [printByStaff description]
     *
     * @memberof TimeRosteredShifts
     * @param  {?} startTime  [description]
     * @param  {?} endTime    [description]
     * @param  {?} roleFilter [description]
     * @return {?}            [description]
     */
    function printByStaff(startTime, endTime, roleFilter) {
      return TimeRostersWebAPI.get({ startTime: startTime, endTime: endTime, byRole: false, roleFilter: roleFilter }).$promise;
    }

    /**
     * [printByRole description]
     *
     * @memberof TimeRosteredShifts
     * @param  {?} startTime  [description]
     * @param  {?} endTime    [description]
     * @param  {?} roleFilter [description]
     * @return {?}            [description]
     */
    function printByRole(startTime, endTime, roleFilter) {
      return TimeRostersWebAPI.get({ startTime: startTime, endTime: endTime, byRole: true, roleFilter: roleFilter }).$promise;
    }

    return {
      getAllForWeek: getAllForWeek,
      getAll: getAll,
      getSummary: getSummary,
      update: update,
      copy: copy,
      remove: remove,
      printByStaff: printByStaff,
      printByRole: printByRole,
      getAllByRosterId: getAllByRosterId
    };
  }]);
